var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('div', {
    staticClass: "vc-overlay rep-app-confirm-dialog",
    attrs: {
      "id": "confirm-modal"
    }
  }, [_c('div', {
    staticClass: "vc-container"
  }, [_c('span', {
    staticClass: "vc-text-grid"
  }, [_c('h4', {
    staticClass: "vc-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "vc-text"
  }, [_vm._v(_vm._s(_vm.message))])]), _c('div', {
    staticClass: "vc-btn-grid"
  }, [_c('button', {
    staticClass: "vc-btn left",
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v("No")]), _c('button', {
    staticClass: "vc-btn right",
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v("Yes")])])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }